'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _exposeHandlers = require('recompose-scope/exposeHandlers');

var _exposeHandlers2 = _interopRequireDefault(_exposeHandlers);

var _exposeNamespace = require('recompose-scope/exposeNamespace');

var _exposeNamespace2 = _interopRequireDefault(_exposeNamespace);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var checkAuth = function checkAuth(_ref) {
  var server = _ref.server,
      setUser = _ref.setUser;
  return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
    var user;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return server.getUser();

          case 3:
            user = _context.sent;

            setUser(user);
            return _context.abrupt('return', user);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](0);

            console.error(_context.t0);
            setUser(null);
            throw _context.t0;

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 8]]);
  }));
};
var login = function login(_ref3) {
  var server = _ref3.server,
      setUser = _ref3.setUser;
  return function () {
    var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(account, password) {
      var user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return server.login(account, password);

            case 3:
              user = _context2.sent;

              setUser(user);
              return _context2.abrupt('return', user);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              console.error(_context2.t0);
              throw _context2.t0;

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, undefined, [[0, 8]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var logout = function logout(_ref5) {
  var server = _ref5.server,
      setUser = _ref5.setUser;
  return _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return server.logout();

          case 3:
            setUser(null);
            _context3.next = 10;
            break;

          case 6:
            _context3.prev = 6;
            _context3.t0 = _context3['catch'](0);

            console.error(_context3.t0);
            throw _context3.t0;

          case 10:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[0, 6]]);
  }));
};
var changePassword = function changePassword(_ref7) {
  var server = _ref7.server,
      user = _ref7.user;
  return function () {
    var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(oldPwd, newPwd) {
      var response;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return server.changePassword(user._id, oldPwd, newPwd);

            case 3:
              response = _context4.sent;
              return _context4.abrupt('return', response);

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4['catch'](0);

              console.error(_context4.t0);
              throw _context4.t0;

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, undefined, [[0, 7]]);
    }));

    return function (_x3, _x4) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var object = _propTypes2.default.object;

var enhancer = (0, _composeWithScope2.default)((0, _getContext2.default)({ server: object }), (0, _withState2.default)('user', 'setUser', null), (0, _exposeHandlers2.default)({
  checkAuth: checkAuth,
  login: login,
  logout: logout,
  changePassword: changePassword
}), (0, _exposeProps2.default)(['user']), (0, _exposeNamespace2.default)('auth'));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'provideAuth');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/provideAuth.js
// module id = 1054
// module chunks = 0